import { reactive } from "vue";

const state = reactive({
    active: false,
    shoppingBag: false,
    profileBar: false,
    notification: false
});

const methods = {
    init: function () {
      var issave = sessionStorage.getItem('isSaveCookie');
      if (issave != null) {
        var parseIssave = JSON.parse(issave);
        if (parseIssave.issave) {
            state.active = false;
        } else {
            state.active = true;
        }
      } else {
        state.active = true;
      }
    },
    acceptCookie: function () {
        state.active = false;
        var item = {
            issave: true,
        }
        sessionStorage.setItem('isSaveCookie', JSON.stringify(item));
    },
    HideBanner: function () {
        state.active = false;
    }
};

export default {
    state: state,
    methods: methods,
}
